import {
    faArrowCircleDown,
    faPercent,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FieldValues, FormProvider, UseFormMethods } from "react-hook-form";
import UnForm from "../../Form";
import { Dispatch, SetStateAction } from "react";
import { IParcelaBoletos } from "../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import { IAcadaDesconto } from "../../../Interfaces/Cobranca/AlcadaDesconto/AlcadaDescontoInterface";

interface IDescontoPrincipalProps {
    valorPrincipal: number;
    setValorPrincipal: Dispatch<SetStateAction<number>>;
    lstParcelasBoletos: IParcelaBoletos[];

    aplicandoPercentualPrincipal: boolean;
    setAplicandoPercentualPrincipal: Dispatch<SetStateAction<boolean>>;

    FormMethods: UseFormMethods<FieldValues>;

    MelhorAlcada: IAcadaDesconto | undefined;
    FLNrAging: boolean | undefined;
    setPorcentagemValorPrincipal: Dispatch<SetStateAction<number>>;

    HandleHonorarioForm: (formData: any) => Promise<void>;
    aplicandoDesconto: boolean;
    porcentagemJuros: number;
    porcentagemMulta: number;
}

export function DescontoPrincipal(props: IDescontoPrincipalProps) {
    const {
        valorPrincipal,
        lstParcelasBoletos,
        aplicandoPercentualPrincipal,
        setAplicandoPercentualPrincipal,
        FormMethods,
        MelhorAlcada,
        setValorPrincipal,
        setPorcentagemValorPrincipal,
        HandleHonorarioForm,
        aplicandoDesconto,
        porcentagemJuros,
        porcentagemMulta,
    } = props;

    const { formState, setValue } = FormMethods;

    return (
        <>
            {MelhorAlcada && MelhorAlcada?.FL_VALOR_PRINCIPAL && (
                <div
                    id="accordion"
                    className="card card-custom w-auto ml-auto wave wave-animate-slow wave-success border-bottom border-1 border-dark"
                >
                    <div className="card-header p-1">
                        <div id="headingThree">
                            <h5 className="mb-0">
                                <button
                                    className="btn btn-link text-decoration-none"
                                    data-toggle="collapse"
                                    data-target="#collapseThree"
                                    aria-expanded="true"
                                    aria-controls="collapseThree"
                                    type="button"
                                >
                                    <div className="d-flex flex-wrap justify-content-between m-1 align-items-center">
                                        <h2 className="p-0 m-0">
                                            PORCENTAGEM DE DESCONTO NO VALOR
                                            REAJUSTADO
                                            <FontAwesomeIcon
                                                icon={faArrowCircleDown}
                                                className="ml-1 mr-1"
                                            />
                                        </h2>
                                    </div>
                                </button>
                            </h5>
                        </div>
                    </div>

                    <div
                        id="collapseThree"
                        className="panel-collapse collapse p-3"
                        aria-labelledby="headingThree"
                        data-parent="#accordion"
                    >
                        <div className="d-flex flex-wrap justify-content-between mb-5 p-3">
                            {/* <div>
             Não existe um número mínimo de parcelas a serem
             selecionadas para aplicar o desconto no valor
             principal.
         </div> */}{" "}
                            <FormProvider {...FormMethods}>
                                <strong>
                                    Para aplicar o percentual é necessário
                                    aplicar 100% de juros e multa.
                                </strong>
                                <UnForm
                                    usingContext
                                    handleSubmit={HandleHonorarioForm}
                                    id="formHonorario"
                                    className="w-100 align-itens-center d-flex flex-wrap justify-content-between mt-3"
                                >
                                    <div className="d-flex flex-row align-items-end">
                                        <div>
                                            <label>Percentual:</label>
                                            <UnForm.Input
                                                type="number"
                                                name="valDescontoVlPrincipal"
                                                maxLength={2}
                                                placeholder={
                                                    "Percentual Valor Principal"
                                                }
                                                defaultValue={0}
                                                step={0.1}
                                                disabled={
                                                    valorPrincipal > 0 ||
                                                    porcentagemJuros !== 100 ||
                                                    porcentagemMulta !== 100 ||
                                                    !aplicandoDesconto
                                                }
                                                max={
                                                    MelhorAlcada.NUM_PERCENTUAL_VALOR_PRINCIPAL
                                                }
                                                onChange={(e) => {
                                                    const value = parseFloat(
                                                        e.target.value
                                                    );
                                                    const maxValue =
                                                        MelhorAlcada.NUM_PERCENTUAL_VALOR_PRINCIPAL;

                                                    if (value > maxValue) {
                                                        e.target.value =
                                                            String(maxValue);
                                                    }
                                                    return setPorcentagemValorPrincipal(
                                                        Number(e.target.value)
                                                    );
                                                }}
                                                className={`form-control px-0 p-2 mr-3 w-100 placeholder-muted-75  ${
                                                    formState.errors
                                                        .valDescontoVlPrincipal &&
                                                    "is-invalid"
                                                }`}
                                            />
                                        </div>
                                        <span className="pb-3 ml-1">
                                            Percentual máximo de:{" "}
                                            {
                                                MelhorAlcada.NUM_PERCENTUAL_VALOR_PRINCIPAL
                                            }
                                            %
                                        </span>
                                    </div>

                                    <div className="d-flex align-items-end">
                                        {!aplicandoPercentualPrincipal ? (
                                            <span>
                                                <UnForm.SubmitButton
                                                    color="primary"
                                                    icon={faPercent}
                                                    onClick={() => {}}
                                                    className="btn btn-outline-primary font-weight-bold d-flex justify-content-center m-1"
                                                    disabled={
                                                        lstParcelasBoletos.length ===
                                                            0 ||
                                                        porcentagemJuros !==
                                                            100 ||
                                                        porcentagemMulta !==
                                                            100 ||
                                                        !aplicandoDesconto
                                                    }
                                                >
                                                    Aplicar Percentual
                                                </UnForm.SubmitButton>
                                            </span>
                                        ) : (
                                            <div>
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        setAplicandoPercentualPrincipal(
                                                            false
                                                        );
                                                        setValorPrincipal(0);
                                                        setPorcentagemValorPrincipal(
                                                            0
                                                        );
                                                        setValue(
                                                            "valDescontoVlPrincipal",
                                                            0
                                                        );
                                                    }}
                                                    className="btn btn-outline-danger font-weight-bold d-flex justify-content-center m-1"
                                                >
                                                    Remover
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </UnForm>
                            </FormProvider>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
